import { render, staticRenderFns } from "./EmailMobileVerification.vue?vue&type=template&id=14dc7d71&scoped=true&"
import script from "./EmailMobileVerification.vue?vue&type=script&lang=js&"
export * from "./EmailMobileVerification.vue?vue&type=script&lang=js&"
import style0 from "./EmailMobileVerification.vue?vue&type=style&index=0&id=14dc7d71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dc7d71",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14dc7d71')) {
      api.createRecord('14dc7d71', component.options)
    } else {
      api.reload('14dc7d71', component.options)
    }
    module.hot.accept("./EmailMobileVerification.vue?vue&type=template&id=14dc7d71&scoped=true&", function () {
      api.rerender('14dc7d71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/EmailMobileVerification.vue"
export default component.exports